import * as moment from 'moment';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dimmer, Form, Grid, Loader, Accordion, Icon } from 'semantic-ui-react';
import { date_format } from '../../global_constants';
import * as report_service from '../action/report_action';
import * as report_constants from '../report_constants';
import * as session_storage from '../../shared/session_storage_utility';
import { handle_click_on_enter, set_focus_on_element_with_id } from '../../shared/tab_navigation_utility';
import { capitalize_fully, custom_date_format, get_columns, remove_duplicates_from_array, format_patient_name } from '../../shared/utility';
import * as export_print_utility from '../util/export_print_utility';
import PatientLedgerReportSearchCriteriaComponent from './patient_ledger_report_search_criteria_component';
import ReportHeader from './report_header';
import {
    deepCopy,
    configureHeaders,
    get_no_charge_values,
    ledger_group_by_charge_column_def,
    ledger_group_by_visit_column_def,
    report,
    row_data_formatter,
    getLabelFromId
} from '../util/patient_ledger_utility';
import { log_error } from '../../shared/action/shared_action';
import ReportGrid from './report_grid';
import ReportFooter from './report_footer';
import PatientLedgerDrawerComponent from './patient_ledger_drawer_component';
import PatientLedgerEditColumnsButtonComponent from './patient_ledger_edit_columns_button_component';
import { Item } from '@webpt/bonfire/dts/components/SortableSelectionList/imp/Models';
import { RccColumnEntity } from '../util/report_column_configuration_utility';
import LedgerPopUpComponent from './ledger_pop_up';
import { AlertConfirm } from '../../shared/component/alert_confirm_component';
import session from 'redux-persist/lib/storage/session';

class PatientLedgerReportComponent extends React.Component<any, any> {
   
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            is_grid_visible: false,
            accordian_is_expanded: true,
            // Report data state
            report_data: [],
            report_rows_count: 0,
            report_title: 'Ledger',
            // Grid configuration
            grid_params: null,
            ledger_footer_obj: null,
            is_search_button_disabled: false,
            is_drawer_opened: false,
            is_export_disabled: true,
            is_print_disabled: true,
            show_edit_columns_button: false,
            init_column_config_items: [],
            column_config_items: [] as Item[],
            temp_column_config_changes: [] as Item[],
            ledger_column_def: ledger_group_by_charge_column_def,
            show_unsaved_config_alert: false,
            column_def: {},
            report_id: null,
            header_id: null,
            // Charge Modal
            is_show_pop_up: false,
            pop_up_data: {
                payment_adjustment: [],
                charges: [],
                claims: []
            },
            row_params: {},
            dos: null,
            case: null,
            // payments and adjustment modal report
            non_charge_values: [],
            chosen_row_cpt_code: ''
        }
    }

    LEDGER_BY_VISIT = 'Ledger By Visit';
    LEDGER_BY_CHARGE = 'Ledger By Charge';
    _is_mounted = false;
    total_column_width: number = 0;
    grid_header_height: number = 0;
    ;
    run_report_date = moment(new Date()).format('MM/DD/YYYY') + ' ' + moment(new Date()).format('hh:mm:ss A');

    UNSAFE_componentWillMount = () => {
        var patient_id = session_storage.get('active_patient') || 0;
        if (!patient_id) {
            this.props.history.push(`/no_patient_selected`);
            return;
        }
    };

    componentWillUnmount = () => {
        document.body.classList.remove('reports', 'patient-header', 'patient-subHeader');
        this._is_mounted = false;
    };

    componentDidMount() {
        this._is_mounted = true;
        document.body.classList.add('reports');
    }

    on_run_report_handler = (search_criteria) => {
        this.setState({ accordian_is_expanded: false });

        var token = this.props.user_login_details.user_data.data.token_details.access_token;
        var search_criteria = { ...search_criteria };
        if (this._is_mounted) {
            this.setState({
                search_criteria: search_criteria,
                loading: true,
                is_search_button_disabled: true,
            });
        }
        // had issue with date format on re-render, working of off a copy to not mutate it
        var copy_search_criteria = {
            ...search_criteria,
            start_date: custom_date_format(search_criteria.start_date._d, date_format['mm-dd-yyyy']),
            end_date: custom_date_format(search_criteria.end_date._d, date_format['mm-dd-yyyy']),
        }

        this.onGetReportComlumnConfig(search_criteria.report_type);

        if (search_criteria.report_type === '1') {
            report_service.get_ledger_report_data(copy_search_criteria, token).then(response => {
                if (response && response.data) {
                    var report_rows = response.data.data ? response.data.data : [];
                    var formatted_data = row_data_formatter(report_rows, report.ledger_by_visit);
                    const grid_height = get_columns(report_rows, ledger_group_by_visit_column_def);
                    this.total_column_width = grid_height.total_column_width;
                    this.grid_header_height = grid_height.header_height;

                    let config_columns = this.state.column_config_items.filter((item) => item.checked).map((item) => item.id);
                    let configured_headers = configureHeaders(config_columns, ledger_group_by_visit_column_def);

                    if (this._is_mounted) {
                        this.setState({
                            loading: false,
                            report_data: formatted_data.data,
                            ledger_column_def: configured_headers,
                            is_grid_visible: true,
                            is_export_disabled: false,
                            is_print_disabled: false,
                            show_date: true,
                            report_rows_count: report_rows && report_rows.length,
                            is_search_button_disabled: false,
                            report_title: this.LEDGER_BY_VISIT,
                            ledger_footer_obj: formatted_data.footer,
                            accordian_is_expanded: false,
                            show_edit_columns_button: true,
                            column_def: ledger_group_by_visit_column_def,
                            report_id: report_constants.report_ledger_group_by_visit_configuration.patient_report_grid_id,
                            header_id: report_constants.report_ledger_group_by_visit_configuration_header_id
                        });
                    }
                    this.run_report_date = moment(new Date()).format('MM/DD/YYYY') + ' ' + moment(new Date()).format('hh:mm:ss A');
                }
            }),
            error => {
                if (this._is_mounted) {
                    this.setState({
                        loading: false,
                        is_search_button_disabled: false
                    });
                }
                log_error(error);
            };
        }

        if (search_criteria.report_type === '2') {
            report_service.get_ledger_report_data(copy_search_criteria, token).then(response => {
                if (response && response.data) {
                    var report_rows = response.data.data ? response.data.data : [];
                    var formatted_data = row_data_formatter(report_rows, report.ledger_by_charge);
                    var non_charge_list = get_no_charge_values(report_rows);
                    const grid_height = get_columns(report_rows, ledger_group_by_charge_column_def);
                    this.total_column_width = grid_height.total_column_width;
                    this.grid_header_height = grid_height.header_height;

                    let config_columns = this.state.column_config_items.filter((item) => item.checked).map((item) => item.id);
                    let configured_headers = configureHeaders(config_columns, ledger_group_by_charge_column_def);

                    if (this._is_mounted) {
                        this.setState({
                            loading: false,
                            report_data: formatted_data.data,
                            ledger_column_def: configured_headers,
                            is_grid_visible: true,
                            is_export_disabled: false,
                            is_print_disabled: false,
                            show_date: true,
                            report_rows_count: report_rows && report_rows.length,
                            is_search_button_disabled: false,
                            report_title: this.LEDGER_BY_CHARGE,
                            ledger_footer_obj: formatted_data.footer,
                            accordian_is_expanded: false,
                            show_edit_columns_button: true,
                            non_charge_values: non_charge_list,
                            column_def: ledger_group_by_charge_column_def,
                            report_id: report_constants.report_ledger_group_by_charge_configuration.patient_report_grid_id,
                            header_id: report_constants.report_ledger_group_by_charge_configuration_header_id
                        });
                    }
                    this.run_report_date = moment(new Date()).format('MM/DD/YYYY') + ' ' + moment(new Date()).format('hh:mm:ss A');
                }
            }),
                error => {
                    if (this._is_mounted) {
                        this.setState({
                            loading: false,
                            is_search_button_disabled: false
                        });
                    }
                    log_error(error);
                };
        }
    };

    clear_handler = () => {
        if (this._is_mounted) {

            this.setState({
                is_grid_visible: false,
                report_rows_count: 0,
                report_title: 'Ledger',
                accordian_is_expanded: true,
                ledger_full_footer_obj: null,
                show_edit_columns_button: false,
                is_export_disabled: true,
                is_print_disabled: true
            });
        }
    };

    toggle_accordian_expand = () => {
        if (this._is_mounted) {
            this.setState({
                accordian_is_expanded: !this.state.accordian_is_expanded
            });
        }
    };

    handle_navigation_after_last_element = event => {
        set_focus_on_element_with_id('app_header_dropdown');
    };

    update_report_rows_count = () => {
        this.setState({
            report_rows_count: this.state.grid_params.api.getModel().getRowCount()
        });
    };

    on_filter_button_click = () => {
        const current_column_def = this.state.ledger_column_def;
        var footer_obj = this.initialize_footer_obj(current_column_def);
        var cell_data;
        var row_api = this.state.grid_params.api;
        if (row_api) {
            row_api.forEachNodeAfterFilter((row, index) => {
                row = row.data;
                current_column_def.map((value, index) => {
                    switch (value.type) {
                        case 'currency':
                            if (row[value.field].indexOf('(') != -1) {
                                cell_data = row[value.field] ? '-' + row[value.field].substring(2, row[value.field].length - 1) : 0;
                            } else {
                                cell_data = row[value.field] ? row[value.field].substring(1, row[value.field].length) : 0;
                            }
                            footer_obj[value.field] += isNaN(parseFloat(cell_data)) ? 0 : parseFloat(cell_data);
                            break;
                        case 'number':
                            footer_obj[value.field] += row[value.field] ? parseInt(row[value.field]) : 0;
                            break;
                        default:
                    }
                });
            });

            current_column_def.map((value, index) => {
                if (value.type == 'currency') {
                    footer_obj[value.field] = report_constants.currencyFormatter(footer_obj[value.field]);
                }
            });
            row_api.setPinnedBottomRowData([footer_obj]);
        }
    };

    //initialize the footer object.
    initialize_footer_obj = column_def => {
        var footer_obj = {};
        column_def.map((value, index) => {
            if (index == 0) {
                footer_obj[value.field] = 'Total';
            } else if (value.type == 'currency' || value.type == 'number') {
                footer_obj[value.field] = 0;
            } else {
                footer_obj[value.field] = null;
            }
        });
        return footer_obj;
    };

    get_grid_ref = grid_params => {
        if (this._is_mounted) {
            this.setState({
                grid_params,
                report_rows_count: grid_params.api.getModel().getRowCount()
            });
        }
        var grid_width = document.getElementsByClassName('ag-body-viewport')[0].clientWidth;
        if (this.total_column_width > grid_width) {
            ledger_group_by_charge_column_def.filter(item => {
                grid_params.columnApi.setColumnWidth(item.field, item['width'], false);
            });
            ledger_group_by_visit_column_def.filter(item => {
                grid_params.columnApi.setColumnWidth(item.field, item['width'], false);
            });
        }
    };

    onEditColumnsButtonHandler = () => {
        if (this._is_mounted) {
            this.setState({
                init_column_config_items: deepCopy(this.state.column_config_items),
                is_drawer_opened: true
            });
        }
    };

    onGetReportComlumnConfig = (report_type = '1') => {

        let session_config = this.getSessionStorage(report_type);

        if (session_config) {
            this.setState({
                column_config_items: JSON.parse(session_config)
            });
        }
        else {
            var token = this.props.user_login_details.user_data.data.token_details.access_token;
            var report_id = report_type == '1' ? report_constants.Ledger_view_by_visit_report_id
                : report_constants.Ledger_view_by_charge_report_id;

            var column_def = report_type == '1' ? ledger_group_by_visit_column_def : ledger_group_by_charge_column_def;

            report_service.get_report_config_view(report_id, token).then(response => {
                if (response && response.data) {
                    var report_rows: RccColumnEntity[] = response.data.data ? response.data.data : [];
                    var columnItems = report_rows
                        .sort((a, b) => a.order - b.order)
                        .map((item, index) => ({
                            id: item.label || index.toString(),
                            label: getLabelFromId(item.label, column_def),
                            checked: item.stateID === 1
                        }));

                    this.setState({
                        column_config_items: columnItems
                    });
                }
            }).catch(error => {
                this.setState({
                    loading: false
                });
                log_error(error);
            });
        }
    }

    getSessionStorage = (report_type: string) => {
        return sessionStorage.getItem("report_column_config_" + report_type);
    }

    setSessionStorage = (items: Item[]) => {
        if (this.state.report_title == this.LEDGER_BY_CHARGE)
            sessionStorage.setItem("report_column_config_" + "2", JSON.stringify(items));
        else
            sessionStorage.setItem("report_column_config_" + "1", JSON.stringify(items));
    }

    onDrawerCloseHandler = (unsaved_changes: boolean, changed_items?: Item[]) => {
        if (unsaved_changes && changed_items && this.containsChanges(changed_items)) {
            this.setState({
                show_unsaved_config_alert: true,
                temp_column_config_changes: changed_items
            });
        }
        else {
            this.setState({
                is_drawer_opened: false
            });
        }
    };

    onDrawerApplyHandler = (selectedItems: Item[]) => {
        let configured_headers = configureHeaders(
                selectedItems.filter((item) => item.checked).map((item) => item.id),
                this.state.column_def);

        this.setState({
            ledger_column_def: configured_headers,
            column_config_items: selectedItems
        });

        this.setSessionStorage(selectedItems);
    };

    containsChanges = (new_items: Item[]) => {
        return this.state.column_config_items
            .some((item, index) =>
                (item.id !== new_items[index].id) ||
                (item.checked != new_items[index].checked));
    }

    onAlertConfirmed = (e) => {
        this.setState({
            show_unsaved_config_alert: false,
            is_drawer_opened: false
        });

        this.onDrawerApplyHandler(this.state.temp_column_config_changes);
    }

    onAlertClosed = (event, data) => {
        this.setState({
            show_unsaved_config_alert: false,
            is_drawer_opened: false
        });
    }

    // Function calls on double click of grid and opens popup
    // To Do, need to replace nested calls with axios.all()
    onCellClicked = async ({ data, column }) => {
        if (!(column.colId == 'dos')) {
            return;
        }
        if (this._is_mounted) {
            this.setState({
                loading: true,
                row_params: data,
                report_name: data.dos ? data.dos : '&nbsp;',
                dos: data.dos,
                chosen_row_cpt_code: data.cpt
            });
        }
        var token = this.props.user_login_details.user_data.data.token_details.access_token;
        var search_criteria = { ...this.state.search_criteria, dos: data.dos };
        // search criterea for the charge and claims log report
        var search_criteria_charges_claims = { patientId: this.state.search_criteria.patient_id, dos: data.dos };
        // search criteria for payments and adjustments report
        var values: String[] = [];
        if (this.state.non_charge_values.length > 0) {
            this.state.non_charge_values.forEach(d => {
                if (d.dos == data.dos && d.not_charge) {
                    values.push(...d.not_charge);
                }
            });
        }
        var search_criteria_payments_adjustments = { patientId: this.state.search_criteria.patient_id, dos: data.dos, nonChargeValues: values };
        
        //TODO: connect to new apis
        let arrData = [];
        let cases: String[] = [];
        arrData.push(report_service.get_new_ledger_charges_report_data(search_criteria_charges_claims, token));
        arrData.push(report_service.get_new_ledger_payment_adjustment_report_data(search_criteria_payments_adjustments, token));
        arrData.push(report_service.get_new_ledger_claims_report_data(search_criteria_charges_claims, token));

        var response = await this.proccessCalls(arrData);
        // resolves syntax error on object structure
        if (!response || !response[0] || !response[0].data || !response[0].data.data) {
            if (this._is_mounted) {
                this.setState({
                    loading: false,
                    is_search_button_disabled: false
                });
            }
            return;
        }
        // get case list and remove duplicates
        var allcases: String[] = response[0].data.data.map(c => {
            // capitalize
            return capitalize_fully(c.case_description)
        });
        // remove duplicates
        cases = remove_duplicates_from_array(allcases);
        if (this._is_mounted) {
            this.setState({
                pop_up_data: {
                    ...this.state.pop_up_data,
                    charges: row_data_formatter(response[0].data.data, report.charges),
                    payment_adjustment: row_data_formatter(response[1].data.data, report.payment_adjustment),
                    claims: row_data_formatter(response[2].data.data, report.claims)
                },
                loading: false,
                is_show_pop_up: true,
                case: cases.toString()
            });
        }
    };

    proccessCalls = async (calls) => {
        try {
            const responses = await Promise.all(calls);
            return responses;
        } catch (error) {
            if (this._is_mounted) {
                this.setState({
                    loading: false
                });
            }
            log_error(error);
            return [];
        }
    }

    //Function calls on click of Close button of popup
    on_pop_up_close = () => {
        if (this._is_mounted) {
            this.setState({ is_show_pop_up: false });
        }
    };

    on_export_btn_click() {
        let export_data = this.set_export_data('\n');
        export_print_utility.export_grid_data(this.state.grid_params, export_data, this.state.report_title);
    }

    on_print_btn_click() {
        let export_data = this.set_export_data('<br>');
        export_print_utility.print_grid_data(this.state.grid_params, export_data, this.state.report_title);
    };

    set_export_data(separator) {
        let company_name = this.props.user_login_details.user_data.data.company_name;

        let patient_name =
            this.props.location.pathname.indexOf('patient') != -1
                ? format_patient_name(this.props.selected_patient.data.name) + separator
                : '';

        let account_no =
            this.props.location.pathname.indexOf('patient') != -1
                ? 'Account#:' + session_storage.get('active_patient') + separator
                : '';

        let current_date = moment(new Date()).format('MM/DD/YYYY') + ' ' + moment(new Date()).format('hh:mm:ss A');

        return (this.state.report_title +
            separator +
            company_name +
            separator +
            patient_name +
            account_no +
            current_date +
            separator +
            (this.state.report_rows_count == 1
                ? this.state.report_rows_count + ' record'
                : this.state.report_rows_count + ' records') +
            separator +
            separator);
    };

    render() {
        return (
            <div className={'common-forms-add financial'}>
                <Dimmer active={this.state.loading}>
                    <Loader size='massive'>Loading</Loader>
                </Dimmer>
                <div className={'common-forms-search report-framework'}>
                    <div id='patient-ledger-report-header-title'>
                        <ReportHeader title={this.state.report_title} />
                    </div>
                    <div id='report-scrollable-area' className='report-wrapper' style={this.state.is_grid_visible ? { flex: 1 } : {}}>
                        <div className='patient-search-form  patient_search_bottom_padding' id='patient-ledger-report-criteria-container'>
                            <Form autoComplete='off'>
                                <Grid>
                                    <Grid.Column computer={16} tablet={16} textAlign='left' className='accordionColumn'>
                                        <Accordion fluid styled id='patient-ledger-search-accordion'>
                                            <Accordion.Title
                                                active={this.state.accordian_is_expanded}
                                                index={0}
                                                onClick={this.toggle_accordian_expand}
                                            >
                                                <Icon onKeyDown={handle_click_on_enter} tabIndex={0} name='angle right' />
                                                Search Criteria
                                            </Accordion.Title>
                                            <Accordion.Content active={this.state.accordian_is_expanded}>
                                                <PatientLedgerReportSearchCriteriaComponent
                                                    on_run_report={this.on_run_report_handler}
                                                    on_clear={this.clear_handler}
                                                    handle_navigation_after_last_element={this.handle_navigation_after_last_element}
                                                    is_search_button_disabled={this.state.is_search_button_disabled}
                                                    onEditColumnsButtonHandler={this.onEditColumnsButtonHandler}
                                                    show_edit_columns_button={false}
                                                />
                                            </Accordion.Content>
                                        </Accordion>
                                        
                                    </Grid.Column>
                                </Grid>
                            </Form>
                        </div>

                        {this.state.is_grid_visible && (
                            <React.Fragment>
                                <Grid className='dateTime'>
                                    <Grid.Column tablet={5} computer={4} textAlign='left'>
                                        <p style={{ fontSize: '16px', minHeight: 22 }}>{this.run_report_date}</p>
                                    </Grid.Column>
                                    <Grid.Column tablet={5} computer={8} textAlign='center'>
                                        {
                                            <p style={{ fontSize: '16px', minHeight: 22 }}>
                                                {`${this.state.report_rows_count} ${this.state.report_rows_count == 1 ? ' record shown' : ' records shown'
                                                    }`}
                                            </p>
                                        }
                                    </Grid.Column>
                                    <Grid.Column tablet={2} computer={4} textAlign='right' >
                                        {
                                            this.state.show_edit_columns_button && (
                                            <div className="patient-ledger-edit-columns-container">
                                                <PatientLedgerEditColumnsButtonComponent
                                                    onEditColumnsButtonHandler={this.onEditColumnsButtonHandler}
                                                />
                                            </div>
                                        )}
                                    </Grid.Column>
                                </Grid>
                                <ReportGrid
                                    id={this.state.report_id}
                                    row={this.state.report_data}
                                    column={this.state.ledger_column_def}
                                    styles={{ height: '100%' }}
                                    wrapperStyle={{ width: '100%', height: '100%', display: 'flex' }}
                                    suppressColumnVirtualisation={true}
                                    suppressMovableColumns={false}
                                    enableColResize={true}
                                    emptyMessage={report_constants.messages.no_records_found}
                                    pinnedBottomRowData={[this.state.ledger_footer_obj]}
                                    get_grid_ref={this.get_grid_ref}
                                    onCellClicked={this.onCellClicked}
                                    on_filter_button_click={() => {
                                        this.on_filter_button_click();
                                        this.update_report_rows_count();
                                    }}
                                    headerHeight={this.grid_header_height}
                                    onGridOut={() => {
                                        set_focus_on_element_with_id('app_header_dropdown');
                                    }}
                                    headerIdForTabNavigation={this.state.header_id}
                                />
                            </React.Fragment>
                        )}

                        {this.state.is_drawer_opened && (
                            <PatientLedgerDrawerComponent
                                isOpen={this.state.is_drawer_opened}
                                onClose={this.onDrawerCloseHandler}
                                onApply={this.onDrawerApplyHandler}
                                initConfigItems={this.state.init_column_config_items}
                            />)}
                    </div>
                    <div
                        className='sixteen wide computer sixteen wide mobile sixteen wide tablet column footer-area'
                        id='applicationFooterSticky'
                    >
                        <ReportFooter
                            on_print_button={() => this.on_print_btn_click()}
                            on_export_button={() => this.on_export_btn_click()}
                            export_disabled={this.state.is_export_disabled}
                            print_disabled={this.state.is_print_disabled}
                        />
                    </div>

                    {this.state.show_unsaved_config_alert &&
                        (
                            <AlertConfirm
                            open={this.state.show_unsaved_config_alert}
                            title={"Unsaved Changes"}
                            message={"Your changes have not been saved. Do you wish to save now?"}
                            labelYes={"Yes"}
                            labelNo={"No"}
                            confirm={this.onAlertConfirmed}
                            close={this.onAlertClosed}
                            cancel={this.onAlertClosed}
                            />
                        )}

                    {this.state.is_show_pop_up && (
                        <LedgerPopUpComponent
                            show_modal={this.state.is_show_pop_up}
                            pop_up_data={this.state.pop_up_data}
                            on_pop_up_close={this.on_pop_up_close}
                            row_params={this.state.row_params}
                            report_name={this.state.report_title}
                            dos={this.state.dos}
                            case_info={this.state.case}
                            chosen_row_cpt_code={this.state.chosen_row_cpt_code}
                        />
                    )}
                </div>
            </div>
        );
    }
}

//Get user and login details from store.
const mapStateToProps = state => {
    return {
        user_login_details: state.user_login_details,
        selected_patient: state.patient_details.patient_header,
        is_expand: state.shared_details.is_expand
    };
};

export default connect(mapStateToProps)(PatientLedgerReportComponent);